/** 28.09 (владелец: «админ зала должен видеть все комментарии DC»): кто и когда писал и правил
 *  комментарий этой брони — «было → стало» из журнала правок. Под строкой «ДК: …» в карточке
 *  клиента (стандартная для всех, не только для админа). Свёрнуто, пока не нужно. */
import { useState } from "react";
import css from "./CommentLog.module.css";

export interface CommentEdit { at: string; by: string; from: string; to: string }

const when = (at: string) => {
  const t = Date.parse(at.includes("T") ? at : `${at.replace(" ", "T")}Z`);
  if (!Number.isFinite(t)) return "";
  const d = new Date(t + 5 * 3_600_000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getUTCDate())}.${p(d.getUTCMonth() + 1)} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
};

export function CommentLog({ log }: { log?: CommentEdit[] | null }) {
  const [open, setOpen] = useState(false);
  if (!log?.length) return null;
  return (
    <div className={css.box}>
      <button type="button" className={css.toggle} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        Правки комментария ДК ({log.length}) {open ? "▴" : "▾"}
      </button>
      {open ? log.map((e, i) => (
        <div key={i} className={css.row}>
          <div className={css.meta}>{when(e.at)} · {e.by || "—"}</div>
          {e.from ? <div className={css.from}>было: {e.from}</div> : null}
          <div className={css.to}>{e.to ? `стало: ${e.to}` : "комментарий стёрт"}</div>
        </div>
      )) : null}
    </div>
  );
}
